// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pga-tour-modal {
  max-width: 1200px;
  width: 95vw;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 12px;
  box-shadow: 0 20px 25px rgba(0, 0, 0, 0.25);
  animation: modalSlideIn 0.3s ease-out;
}

.pga-tour-modal .modal-content {
  flex: 1 1;
  overflow-y: auto;
  padding: 1.5rem;
}

.tournament-summary {
  background: #f8fafc;
  padding: 1.5rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  border-left: 4px solid #2563eb;
  border: 1px solid #e2e8f0;
}

.tournament-summary p {
  margin: 0 0 1rem 0;
  color: #374151;
  line-height: 1.5;
  font-size: 0.95rem;
}

.selection-controls {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.select-all-btn {
  background: #475569;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s;
}

.select-all-btn:hover {
  background: #64748b;
}

.selection-count {
  font-weight: 600;
  color: #374151;
  font-size: 0.875rem;
}

.tournaments-table-container {
  margin: 1.5rem 0;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.tournaments-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
  background: white;
}

.tournaments-table th {
  background: #f8fafc;
  padding: 0.75rem 1rem;
  text-align: left;
  font-weight: 600;
  color: #374151;
  border-bottom: 2px solid #e2e8f0;
  position: sticky;
  top: 0;
  z-index: 10;
  font-size: 0.875rem;
}

.tournaments-table td {
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: top;
  color: #64748b;
  font-size: 0.875rem;
}

.tournaments-table tr:hover {
  background: #f8fafc;
}

.tournament-checkbox {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.tournament-name {
  min-width: 200px;
}

.tournament-name strong {
  color: #1e293b;
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.major-badge, .signature-badge {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  margin-left: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.major-badge {
  background: #fef3c7;
  color: #92400e;
}

.signature-badge {
  background: #dbeafe;
  color: #1e40af;
}

.tournament-dates {
  min-width: 120px;
}

.date-range {
  font-size: 0.875rem;
  line-height: 1.4;
  color: #64748b;
}

.date-range div {
  margin-bottom: 0.25rem;
}

.tournament-venue {
  min-width: 180px;
  max-width: 200px;
  word-wrap: break-word;
}

.tournament-winner {
  min-width: 120px;
  font-weight: 500;
  color: #374151;
}

.tournament-purse {
  min-width: 100px;
  text-align: right;
  font-family: monospace;
  font-weight: 600;
  color: #059669;
}

.import-notes {
  background: #eff6ff;
  padding: 1.5rem;
  border-radius: 8px;
  margin: 1.5rem 0;
  border-left: 4px solid #2563eb;
  border: 1px solid #dbeafe;
}

.import-notes h4 {
  margin: 0 0 1rem 0;
  color: #1e40af;
  font-size: 1rem;
  font-weight: 600;
}

.import-notes ul {
  margin: 0;
  padding-left: 1.5rem;
  color: #374151;
}

.import-notes li {
  margin-bottom: 0.5rem;
  line-height: 1.4;
  font-size: 0.875rem;
}

.import-notes strong {
  color: #1e40af;
  font-weight: 600;
}

.error-message {
  background: #fef2f2;
  color: #dc2626;
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  border-left: 4px solid #dc2626;
  border: 1px solid #fecaca;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.875rem;
}

.loading-state {
  text-align: center;
  padding: 2.5rem 1.5rem;
  color: #64748b;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f4f6;
  border-top: 4px solid #2563eb;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 1.5rem;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.modal-actions {
  padding: 1.5rem;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  background: #f8fafc;
}

.cancel-btn {
  background: #475569;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 0.375rem;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s;
}

.cancel-btn:hover {
  background: #64748b;
}

.confirm-btn {
  background: #059669;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 0.375rem;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 600;
  transition: all 0.2s;
  box-shadow: 0 2px 4px rgba(5, 150, 105, 0.2);
}

.confirm-btn:hover:not(:disabled) {
  background: #047857;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(5, 150, 105, 0.3);
}

.confirm-btn:disabled {
  background: #6b7280;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* Modal overlay and animations */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 1rem;
}

.modal-header {
  padding: 1.5rem 1.5rem 1rem;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h2 {
  margin: 0;
  color: #1e293b;
  font-size: 1.5rem;
  font-weight: 700;
}

.modal-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #64748b;
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.modal-close:hover {
  background-color: #f1f5f9;
  color: #374151;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive design */
@media (max-width: 768px) {
  .pga-tour-modal {
    width: 98vw;
    max-height: 95vh;
    margin: 0.5rem;
  }
  
  .modal-header {
    padding: 1rem;
  }
  
  .modal-header h2 {
    font-size: 1.25rem;
  }
  
  .pga-tour-modal .modal-content {
    padding: 1rem;
  }
  
  .tournaments-table {
    font-size: 0.75rem;
  }
  
  .tournaments-table th,
  .tournaments-table td {
    padding: 0.5rem 0.25rem;
  }
  
  .tournament-name,
  .tournament-venue {
    min-width: 120px;
  }
  
  .selection-controls {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }
  
  .modal-actions {
    padding: 1rem;
    flex-direction: column;
  }
  
  .modal-actions button {
    width: 100%;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/admin/modals/PGATourFetchModal.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,8BAA8B;EAC9B,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".pga-tour-modal {\n  max-width: 1200px;\n  width: 95vw;\n  max-height: 90vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 20px 25px rgba(0, 0, 0, 0.25);\n  animation: modalSlideIn 0.3s ease-out;\n}\n\n.pga-tour-modal .modal-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 1.5rem;\n}\n\n.tournament-summary {\n  background: #f8fafc;\n  padding: 1.5rem;\n  border-radius: 8px;\n  margin-bottom: 1.5rem;\n  border-left: 4px solid #2563eb;\n  border: 1px solid #e2e8f0;\n}\n\n.tournament-summary p {\n  margin: 0 0 1rem 0;\n  color: #374151;\n  line-height: 1.5;\n  font-size: 0.95rem;\n}\n\n.selection-controls {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.select-all-btn {\n  background: #475569;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 0.375rem;\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 500;\n  transition: all 0.2s;\n}\n\n.select-all-btn:hover {\n  background: #64748b;\n}\n\n.selection-count {\n  font-weight: 600;\n  color: #374151;\n  font-size: 0.875rem;\n}\n\n.tournaments-table-container {\n  margin: 1.5rem 0;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.tournaments-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n  background: white;\n}\n\n.tournaments-table th {\n  background: #f8fafc;\n  padding: 0.75rem 1rem;\n  text-align: left;\n  font-weight: 600;\n  color: #374151;\n  border-bottom: 2px solid #e2e8f0;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  font-size: 0.875rem;\n}\n\n.tournaments-table td {\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid #f1f5f9;\n  vertical-align: top;\n  color: #64748b;\n  font-size: 0.875rem;\n}\n\n.tournaments-table tr:hover {\n  background: #f8fafc;\n}\n\n.tournament-checkbox {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n\n.tournament-name {\n  min-width: 200px;\n}\n\n.tournament-name strong {\n  color: #1e293b;\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n}\n\n.major-badge, .signature-badge {\n  display: inline-block;\n  padding: 0.25rem 0.5rem;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  margin-left: 0.5rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.major-badge {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.signature-badge {\n  background: #dbeafe;\n  color: #1e40af;\n}\n\n.tournament-dates {\n  min-width: 120px;\n}\n\n.date-range {\n  font-size: 0.875rem;\n  line-height: 1.4;\n  color: #64748b;\n}\n\n.date-range div {\n  margin-bottom: 0.25rem;\n}\n\n.tournament-venue {\n  min-width: 180px;\n  max-width: 200px;\n  word-wrap: break-word;\n}\n\n.tournament-winner {\n  min-width: 120px;\n  font-weight: 500;\n  color: #374151;\n}\n\n.tournament-purse {\n  min-width: 100px;\n  text-align: right;\n  font-family: monospace;\n  font-weight: 600;\n  color: #059669;\n}\n\n.import-notes {\n  background: #eff6ff;\n  padding: 1.5rem;\n  border-radius: 8px;\n  margin: 1.5rem 0;\n  border-left: 4px solid #2563eb;\n  border: 1px solid #dbeafe;\n}\n\n.import-notes h4 {\n  margin: 0 0 1rem 0;\n  color: #1e40af;\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.import-notes ul {\n  margin: 0;\n  padding-left: 1.5rem;\n  color: #374151;\n}\n\n.import-notes li {\n  margin-bottom: 0.5rem;\n  line-height: 1.4;\n  font-size: 0.875rem;\n}\n\n.import-notes strong {\n  color: #1e40af;\n  font-weight: 600;\n}\n\n.error-message {\n  background: #fef2f2;\n  color: #dc2626;\n  padding: 1rem;\n  border-radius: 8px;\n  margin-bottom: 1.5rem;\n  border-left: 4px solid #dc2626;\n  border: 1px solid #fecaca;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 0.875rem;\n}\n\n.loading-state {\n  text-align: center;\n  padding: 2.5rem 1.5rem;\n  color: #64748b;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #f3f4f6;\n  border-top: 4px solid #2563eb;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 0 auto 1.5rem;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.modal-actions {\n  padding: 1.5rem;\n  border-top: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  background: #f8fafc;\n}\n\n.cancel-btn {\n  background: #475569;\n  color: white;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 0.375rem;\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 500;\n  transition: all 0.2s;\n}\n\n.cancel-btn:hover {\n  background: #64748b;\n}\n\n.confirm-btn {\n  background: #059669;\n  color: white;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 0.375rem;\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 600;\n  transition: all 0.2s;\n  box-shadow: 0 2px 4px rgba(5, 150, 105, 0.2);\n}\n\n.confirm-btn:hover:not(:disabled) {\n  background: #047857;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(5, 150, 105, 0.3);\n}\n\n.confirm-btn:disabled {\n  background: #6b7280;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n/* Modal overlay and animations */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  padding: 1rem;\n}\n\n.modal-header {\n  padding: 1.5rem 1.5rem 1rem;\n  border-bottom: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.modal-header h2 {\n  margin: 0;\n  color: #1e293b;\n  font-size: 1.5rem;\n  font-weight: 700;\n}\n\n.modal-close {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  color: #64748b;\n  cursor: pointer;\n  padding: 0.25rem;\n  border-radius: 4px;\n  transition: all 0.3s ease;\n}\n\n.modal-close:hover {\n  background-color: #f1f5f9;\n  color: #374151;\n}\n\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .pga-tour-modal {\n    width: 98vw;\n    max-height: 95vh;\n    margin: 0.5rem;\n  }\n  \n  .modal-header {\n    padding: 1rem;\n  }\n  \n  .modal-header h2 {\n    font-size: 1.25rem;\n  }\n  \n  .pga-tour-modal .modal-content {\n    padding: 1rem;\n  }\n  \n  .tournaments-table {\n    font-size: 0.75rem;\n  }\n  \n  .tournaments-table th,\n  .tournaments-table td {\n    padding: 0.5rem 0.25rem;\n  }\n  \n  .tournament-name,\n  .tournament-venue {\n    min-width: 120px;\n  }\n  \n  .selection-controls {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.75rem;\n  }\n  \n  .modal-actions {\n    padding: 1rem;\n    flex-direction: column;\n  }\n  \n  .modal-actions button {\n    width: 100%;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
